import { isEmpty } from "lodash-es";
import type { $ZodErrorTree } from "zod/v4/core";

export type ErrorProps = {
  error: boolean;
  helperText?: string;
};

export function extractZodTreeErrorProps<T>(
  errors: { display: boolean; errors: $ZodErrorTree<T> | null },
  path: Array<string | number>,
): ErrorProps {
  if (!errors.display || !errors.errors) return { error: false };

  const error = getZodErrorTreeErrorAtPath(errors.errors, path);
  return {
    error: !isEmpty(error),
    helperText: error,
  };
}

function getZodErrorTreeErrorAtPath<T>(
  errorObj: $ZodErrorTree<T>,
  path: Array<string | number>,
): string | undefined {
  let acc: unknown = errorObj;

  for (const key of path) {
    // First, if acc has a "properties" field, dive into it automatically:
    if (
      acc !== null &&
      typeof acc === "object" &&
      "properties" in (acc as Record<string, unknown>)
    ) {
      acc = (acc as Record<string, unknown>)["properties"];
    }

    // Then try to access the key:
    if (acc !== null && (typeof acc === "object" || Array.isArray(acc))) {
      acc = (acc as Record<string | number, unknown>)[key];
    } else {
      // if we can't go deeper, stop and return undefined
      return undefined;
    }
  }

  return Array.isArray(acc)
    ? (acc as string[]).join(", ")
    : typeof acc === "object" && acc !== null && "errors" in (acc as Record<string, unknown>)
      ? ((acc as { errors?: string[] }).errors?.join(", ") ?? undefined)
      : undefined;
}
